export const MAX_RETRIES = 3
export const RETRY_DELAY_MS = 3000

export const PAYMENT_STEPS = {
  SHOPPING_CART: 1,
  PAYMENT_METHOD: 2,
  PAYER_INFO: 3,
  NFE_INFO: 4,
  PAYMENT_SUMMARY: 5,
}

export const PRODUCT_TYPE = {
  IMAGE_PROCESSING: "IMAGE_PROCESSING",
  POST_PROCESSING: "POST_PROCESSING",
  SUBSCRIPTION: "SUBSCRIPTION",
  SUBSCRIPTION_UPDATE: "SUBSCRIPTION_UPDATE",
  PHYSICAL_PRODUCT: "PHYSICAL_PRODUCT",
}

export const DOCUMENT_TYPE = {
  CPF: "CPF",
  CNPJ: "CNPJ",
}

export const PAYMENT_METHOD = {
  SAVED_CREDIT_CARD: "saved-credit-card",
  CREDIT_CARD: "credit-card",
  POST_PAY: "postpay",
  NO_TYPE: "no-type",
  BOACOMPRA: "boacompra",
}

export const CREDIT_CARD_BRAND = {
  MAESTRO: "maestro",
  MASTERCARD: "mastercard",
  VISA: "visa",
  ELO: "elo",
  AMEX: "amex",
}

export const CREDIT_CARD_LOGO = {
  ["maestro"]: "card-logo small mastercard",
  ["mastercard"]: "card-logo small mastercard",
  ["visa"]: "card-logo small visa",
  ["elo"]: "card-logo small elo",
  ["amex"]: "card-logo small amex",
}

export const PAYABLE_WITH = {
  ALL: "ALL",
  CREDIT_CARD: "credit-card",
  POST_PAY: "postpay",
}

export const PAYMENT_COUNTRY = ["AR", "BR", "CL", "CO", "MX", "PT", "ES", "TR", "UY", "US"]

export const PAYMENT_COUNTRY_LANGUAGE = {
  "BR": "pt_BR",
  "AR": "es_ES",
  "CL": "es_ES",
  "CO": "es_ES",
  "BO": "es_ES",
  "EC": "es_ES",
  "PY": "es_ES",
  "UR": "es_ES",
  "PE": "es_ES",
  "VE": "es_ES",
  "ES": "es_ES",
  "DEFAULT": "en_US",
}

export const STATES = [
  {value: "AC", text: "Acre"},
  {value: "AL", text: "Alagoas"},
  {value: "AP", text: "Amapá"},
  {value: "AM", text: "Amazonas"},
  {value: "BA", text: "Bahia"},
  {value: "CE", text: "Ceará"},
  {value: "DF", text: "Distrito Federal"},
  {value: "ES", text: "Espírito Santo"},
  {value: "GO", text: "Goiás"},
  {value: "MA", text: "Maranhão"},
  {value: "MT", text: "Mato Grosso"},
  {value: "MS", text: "Mato Grosso do Sul"},
  {value: "MG", text: "Minas Gerais"},
  {value: "PA", text: "Pará"},
  {value: "PB", text: "Paraíba"},
  {value: "PR", text: "Paraná"},
  {value: "PE", text: "Pernambuco"},
  {value: "PI", text: "Piauí"},
  {value: "RJ", text: "Rio de Janeiro"},
  {value: "RN", text: "Rio Grande do Norte"},
  {value: "RS", text: "Rio Grande do Sul"},
  {value: "RO", text: "Rondônia"},
  {value: "RR", text: "Roraima"},
  {value: "SC", text: "Santa Catarina"},
  {value: "SP", text: "São Paulo"},
  {value: "SE", text: "Sergipe"},
  {value: "TO", text: "Tocantins"},
]

